// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b96ccf41","455":"8d0fa3df","977":"9eb28595"}[chunkId] + ".chunk.js";
};